<!-- eslint-disable max-len -->
<template>
  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.37484 2.00075V2.00016C1.37484 1.46552 1.80766 1.0335 2.33317 1.0335H15.6665C16.1966 1.0335 16.6332 1.4701 16.6332 2.00016V12.0002C16.6332 12.5302 16.1966 12.9668 15.6665 12.9668H2.33317C1.80319 12.9668 1.36664 12.5304 1.3665 12.0004C1.3665 12.0003 1.3665 12.0002 1.3665 12.0002L1.37484 2.00075Z"
      stroke="#C2CFE0"
      stroke-width="1.4"
    />
    <path d="M1.5 2L9 7L16.5 2" stroke="#C2CFE0" stroke-width="1.4" />
  </svg>
</template>
<script>
export default {
  name: 'sources',
};
</script>
